import React from 'react';
import { Box, Typography } from '@mui/material';

const STEP_COUNT = 3;

/**
 * De voortgang van een ronde als drie balkjes: gespeeld → opgehaald →
 * gecontroleerd. Eén blik is genoeg om te zien waar een ronde staat, en het label
 * eronder zegt in getallen hetzelfde.
 */
function RoundProgress({ progress }) {
    if (progress.matchCount === 0) {
        return <Typography variant="caption" color="text.secondary">geen wedstrijden</Typography>;
    }

    return (
        <Box>
            <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                {Array.from({ length: STEP_COUNT }, (unused, index) => (
                    <Box
                        key={index}
                        sx={{
                            width: 34,
                            height: 6,
                            borderRadius: 3,
                            bgcolor: index < progress.step ? 'success.main' : 'rgba(255, 255, 255, 0.15)',
                        }}
                    />
                ))}
            </Box>
            <Typography
                variant="caption"
                sx={{ display: 'block', mt: 0.5, color: progress.step === STEP_COUNT ? 'success.main' : 'text.secondary' }}
            >
                {progress.label}
                {progress.corrections > 0 && ` · ${progress.corrections} correctie(s)`}
            </Typography>
        </Box>
    );
}

export default RoundProgress;
